<div class="grid tk-grid-rows place-items-center h-screen tk-bg-gray-1 tk-i-background">

  <div class="mx-auto flex-1 flex-col place-items-center w-80">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center">{{'create-account-confirmation.email-assigned' | translate}}</div>

    <div class="mt-4 text-sm text-center">{{'create-account-confirmation.how-to-login' | translate}}</div>

    <button type="button" class="mt-11 btn-submit rounded w-full hover:font-normal" (click)="onToLogin()">
      <div class="my-3 text-base text-white text-center">{{'authentication-shared.goto-login' | translate}}</div>
    </button>
  </div>

  <am-login-footer class="mb-8 w-full"></am-login-footer>

</div>

